export const transportClassKeys: Record<string, { labelKey: string }> = {
  STANDARD: { labelKey: 'journey.class_standard' },
  STANDARD_PREMIER: { labelKey: 'journey.class_standard_premier' },
  BUSINESS_PREMIER: { labelKey: 'journey.class_business_premier' },
  FIRST_CLASS: { labelKey: 'journey.class_first' },
  BUSINESS_CLASS: { labelKey: 'journey.class_business' },
  EXECUTIVE_CLASS: { labelKey: 'journey.class_executive' },
  EXCELLENCE_CLASS: { labelKey: 'journey.class_excellence' },
  ELIGE_CONFORT: { labelKey: 'journey.class_elige_confort' },
  PREMIUM: { labelKey: 'journey.class_premium' },
  COMFORT_CLASS: { labelKey: 'journey.class_comfort' },
  EUROSTAR_STANDARD: { labelKey: 'journey.class_eurostar_standard' },
  EUROSTAR_PLUS: { labelKey: 'journey.class_eurostar_plus' },
  EUROSTAR_PREMIER: { labelKey: 'journey.class_eurostar_premier' },
  PRIVATE_COMPARTMENT: { labelKey: 'journey.class_private_compartment' } // Derived - displays if overnight trip
};
